/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-16 17:16:27
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-16 17:18:26
 */


/**
 * @brief: 首字母大写
 * @author: Scarlett Xiao
 * @Date: 2021-03-05 15:35:17
 * @param {any} value 字符串
 */
const capitalize = function (value) {
  try {
    let string = value.trim();
    string = string.substr(0, 1).toUpperCase() + string.slice(1);
    return string;
  } catch (error) {}
  return value;
}

export {
  capitalize
}